// removed by extract-text-webpack-plugin
module.exports = {"container":"container-hHHzE","modal":"modal-1eocw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/modal-dialog/style.scss
 ** module id = 22
 ** module chunks = 0
 **/